import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../lib/i18n";

/**
 * Başlığın altındakı alt kateqoriya sətri (tapşırıq 2026-10-05).
 *
 * Şaquli xətlərlə ayrılmış «Hamısı | Gündəlik | Klassik» ilk variantı sahib
 * bəyənmədi — daha sadə və brendə məxsus olsun. İndi: ayırıcı yoxdur, adlar
 * yuxarı menyunun dilində (kiçik, böyük hərf, geniş hərf arası), yanında
 * qızılı (champagne) üst-indeks məhsul sayı, aktiv bəndin altında menyudakı
 * eyni incə xətt. Hər bənd öz URL-i olan adi linkdir, seçim səhifə yenilənəndə
 * qalır; mobil-də sətir üfüqi sürüşür, kənarı solğunlaşır.
 *
 *   items: [{ key, label, to, active, count }]
 */
export default function CategorySubnav({
  items = [], allTo, allActive, allCount = null, label, testId = "category-subnav",
}) {
  const { locale } = useI18n();
  if (!items.length) return null;
  const allLabel = locale === "az" ? "Hamısı" : "All";
  return (
    <nav className="adf-subnav" aria-label={label || (locale === "az" ? "Alt kateqoriyalar" : "Subcategories")} data-testid={testId}>
      <ul className="adf-subnav__list">
        <SubnavItem to={allTo} label={allLabel} active={allActive} count={allCount} testId={`${testId}-all`} />
        {items.map((item) => (
          <SubnavItem
            key={item.key}
            to={item.to}
            label={item.label}
            active={item.active}
            count={item.count}
            testId={`${testId}-${item.key}`}
          />
        ))}
      </ul>
    </nav>
  );
}

function SubnavItem({ to, label, active, count, testId }) {
  const hasCount = typeof count === "number" && count > 0;
  return (
    <li className="adf-subnav__item">
      <Link to={to} className="adf-subnav__link" aria-current={active ? "true" : undefined} data-testid={testId}>
        <span className="adf-subnav__label">{label}</span>
        {hasCount && <sup className="adf-subnav__count">{count}</sup>}
      </Link>
    </li>
  );
}
